export default __webpack_public_path__ + "static/media/radiant.8dd3152d.svg";